import { logUtil } from 'packages/src'

export default function scrollToTopDomUtil (animate) {
  if (!BROWSER) {
    return
  }

  logUtil('scrollToTopDomUtil').debug('[start]')
  if (animate && window.scrollBy) {
    window.scrollBy({
      x: 0,
      top: -document.documentElement.scrollHeight,
      behavior: 'smooth'
    })
    return
  }
  window.scrollTo(0, 0)
}
